import { render, staticRenderFns } from "./Booker.vue?vue&type=template&id=52e2b85d"
import script from "./Booker.vue?vue&type=script&lang=js"
export * from "./Booker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports